const commonUtils = {
  getDisplayTime: function(count) {
    const minutes = Math.floor(count / 60);
    const seconds = count - 60 * minutes;
    const secondPrefix = seconds > 9 ? '' : '0';
    const timeDisplay = count >= 0 ? `${minutes}:${secondPrefix}${seconds}` : 'not started';

    return timeDisplay;
  }
};

export default commonUtils;
